import Autolinker from 'autolinker';

export const formatLinks = (text, options = null) => Autolinker.link(text, options);

export const escapeRegExp = string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const escapeHtml = unsafe => {
  if (!unsafe) return '';

  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

export const stringEmpty = str => !str || str.trim().length === 0;



// WEBPACK FOOTER //
// ./app/javascript/common/utils/text.js